import { Dispatch, SetStateAction, useMemo } from 'react';
import { defineMessages } from 'react-intl';
import Toast from '@alltrails/denali/components/Toast';
import TextArea from '@alltrails/denali/components/TextArea';
import Error from '@alltrails/denali/icons/Error';
import { useFormatMessage } from '@alltrails/language/hooks/useFormatMessage';
import { Issue, Report, ReportedUser } from '../../types';
import ReportRow from '../ReportRow/ReportRow';
import BlockUserSection from '../BlockUserSection/BlockUserSection';

const messages = defineMessages({
  saveError: { defaultMessage: 'Something went wrong. Please try again.' }
});

type ReportDrilldownProps = {
  report?: Report;
  reportUser?: ReportedUser;
  isBlockSelected: boolean;
  setIsBlockSelected: Dispatch<SetStateAction<boolean>>;
  otherReason: string;
  setOtherReason: Dispatch<SetStateAction<string>>;
  errorToastVisible: boolean;
  hasRealUser?: boolean;
};

export default function ReportDrilldown({
  report,
  reportUser,
  isBlockSelected,
  setIsBlockSelected,
  otherReason,
  setOtherReason,
  errorToastVisible,
  hasRealUser
}: ReportDrilldownProps) {
  const {
    formattedDefaultMessages: { saveError }
  } = useFormatMessage(messages);
  const renderReport = useMemo(() => {
    if (!report) {
      return null;
    }
    return report.id === Issue.Other ? (
      <TextArea labelText="" value={otherReason} onChange={value => setOtherReason(value)} testId="report-issue-other" rows={4} />
    ) : (
      <ReportRow report={report} />
    );
  }, [report, otherReason, setOtherReason]);

  return (
    <>
      <div>
        {renderReport}
        {reportUser && hasRealUser && (
          <BlockUserSection reportUser={reportUser} blockActive={isBlockSelected} onBlockToggle={setIsBlockSelected} />
        )}
      </div>
      <Toast
        isOpen={errorToastVisible}
        message={saveError}
        position="alternative"
        type="error"
        testId="report-error-toast"
        icon={{ Component: Error }}
      />
    </>
  );
}
